import { render, staticRenderFns } from "./register-family.vue?vue&type=template&id=7bcf8ab7&scoped=true&"
import script from "./register-family.vue?vue&type=script&lang=js&"
export * from "./register-family.vue?vue&type=script&lang=js&"
import style0 from "./register-family.vue?vue&type=style&index=0&id=7bcf8ab7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcf8ab7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VForm,VSelect,VTextField})
